const faqAvatars = [
  require('./avatars/01-arctic-fox.webp'),
  require('./avatars/02-rabbit.webp'),
  require('./avatars/03-owl.webp'),
  require('./avatars/04-otter.webp'),
  require('./avatars/05-red-panda.webp'),
  require('./avatars/06-penguin.webp'),
];

export default faqAvatars;
